import logo from "./logo.svg";
import "./App.css";
import { OrgRegister } from "./pages/OrgRegister";
import { OrgLogin } from "./pages/OrgLogin";
import { Main } from "./pages/Main";
import { useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Services } from "./components/services/Services";
import { Business } from "./components/business/Business";
import { Profile } from "./components/business/Profile";
import { Timings } from "./components/business/Timings";
import { Holidays } from "./components/business/Holidays";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { Provider } from "react-redux";
import { store } from "./api/store";
import { Appointments } from "./components/appointments/Appointments";
import { ThemeProvider } from "@mui/material";
import { createTheme, ThemeOptions } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#002979",
    },
    secondary: {
      main: "#144FC3",
    },
  },
});

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "dashboard",
        element: <Appointments />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "business",
        element: <Business />,
        children: [
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "timings",
            element: <Timings />,
          },
          {
            path: "holidays",
            element: <Holidays />,
          },
        ],
      },
      {
        path: "help",
        element: <div>Help</div>,
      },
    ],
  },
  {
    path: "/login",
    element: <OrgLogin />,
  },
  {
    path: "/register",
    element: <OrgRegister />,
  },
]);

function App() {
  const [login, setLogin] = useState(false);
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </Provider>
      </QueryClientProvider>
    </>
  );
}

export default App;
